import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import "@/config/ui2024";
import filter from "./utils/filter";
import { category, majorID, majorTag } from "@base/settings";

// 引入 vue-kikindeditor 需要的文件
import VueKindEditor from "vue-kindeditor";
import "kindeditor/kindeditor-all-min.js";
import "kindeditor/themes/default/default.css";

Vue.prototype.$categoryInfo = {
  category: category,
  majorID: majorID,
  majorTag: majorTag
};
//全局导入过滤器
Object.keys(filter).forEach(key => Vue.filter(key, filter[key]));

Vue.config.productionTip = false;
Vue.use(VueKindEditor);

//计算器
window.math.config({ number: "BigNumber" });
Vue.prototype.$math = window.math;
window["_calc_element"] = "test";

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
